<template>
	<el-dialog title="待审核" :visible="visible" :close-on-click-modal="false" @close="close">
		<el-row :gutter="20" class="i-stats">
			<el-col :span="8">
				<el-link :underline="false" class="i-card" @click="push('/customer/audit-index');close()">
					<el-statistic :value="$store.state.pendingAudit.customerCount" title="新客户" />
				</el-link>
			</el-col>
			<el-col :span="8">
				<el-link :underline="false" class="i-card" @click="push('/purchase');close()">
					<el-statistic :value="$store.state.pendingAudit.purchaseCount" title="采购" />
				</el-link>
			</el-col>
			<el-col :span="8">
				<el-link :underline="false" class="i-card" @click="push('/purchase/refund');close()">
					<el-statistic :value="$store.state.pendingAudit.purchaseRefundCount" title="采购退货" />
				</el-link>
			</el-col>
			<el-col :span="8">
				<el-link :underline="false" class="i-card" @click="push('/order');close()">
					<el-statistic :value="$store.state.pendingAudit.orderCount" title="订单" />
				</el-link>
			</el-col>
			<el-col :span="8">
				<el-link :underline="false" class="i-card" @click="push('/order/refund');close()">
					<el-statistic :value="$store.state.pendingAudit.orderRefundCount" title="订单退款" />
				</el-link>
			</el-col>
			<el-col :span="8">
				<el-link :underline="false" class="i-card" @click="push('/made/design');close()">
					<el-statistic :value="$store.state.pendingAudit.designCount" title="图纸设计" />
				</el-link>
			</el-col>
			<el-col :span="8">
				<el-link :underline="false" class="i-card" @click="push('/finance/salary');close()">
					<el-statistic :value="$store.state.pendingAudit.salaryCount" title="薪资" />
				</el-link>
			</el-col>
			<el-col :span="8">
				<el-link :underline="false" class="i-card" @click="push('/finance/perk');close()">
					<el-statistic :value="$store.state.pendingAudit.perkCount" title="补助" />
				</el-link>
			</el-col>
			<el-col :span="8">
				<el-link :underline="false" class="i-card" @click="push('/finance/bill');close()">
					<el-statistic :value="$store.state.pendingAudit.billCount" title="账单" />
				</el-link>
			</el-col>
		</el-row>
	</el-dialog>
</template>

<script>
import router from '@/mixins/router'
export default {
	name: 'PendingAudit',
	mixins: [router],
	props: {
		visible: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		close() {
			this.$emit('update:visible', false)
		}
	}
}
</script>